// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2VqSt","additionalInfo":"AgreementModal_additionalInfo__3xjeB"};